import comp from '../components/barrel';
import listReturnState from '../js/listReturnState';

const EP = 'advisors/get-lead-details';
const USER_EP = 'users/get-user-details';
const MARKETERS_EP = 'communal/marketers';

const VIEW_LEAD_TABS = {
  VLd_Details: {
    html_text: 'VLd_Details',
    short_text: 'Details',
    activeTab: true,
    subMenu: [],
  },
  VLd_ContactReports: {
    html_text: 'VLd_ContactReports',
    short_text: 'Contact reports',
    activeTab: false,
    subMenu: [],
  },
};

export default {
  tabsYN: 0,

  async prepare() {
    if (this.vars && this.vars.listRestore && this.vars.listRestore.lead_uuid) {
      this.vars.lead_uuid = this.vars.listRestore.lead_uuid;
    }
    const lead_uuid = this.vars && this.vars.lead_uuid ? String(this.vars.lead_uuid) : '';
    if (lead_uuid) this.recipe.methods.push(await O.mPOST(EP, {lead_uuid}));
    this.recipe.methods.push(await O.mPOST(MARKETERS_EP, {}));
    const {value: loggedInUuid} = await O.getCookie('ewttgpvwwkf');
    this.loggedInUuid = loggedInUuid || null;
    if (loggedInUuid) {
      this.recipe.methods.push(await O.mPOST(USER_EP, {target_user_uuid: loggedInUuid}));
    }
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) data = await O.PREP(rec);
    await this.loadPage(data);
  },

  async loadPage(data) {
    this.tabs = VIEW_LEAD_TABS;
    try {
      const state = history.state ? JSON.parse(history.state) : {};
      state.tabs = VIEW_LEAD_TABS;
      history.replaceState(JSON.stringify(state), '', 'ViewLead');
    } catch (e) {
      /* ignore */
    }

    const userDetails = data[USER_EP]?.data;
    this.loggedInRoleText = userDetails?.role_text || null;
    this.isMarketer = (this.loggedInRoleText || '').trim().toLowerCase() === 'marketer';
    const marketersRes = data[MARKETERS_EP] || {};
    this.marketersData = Array.isArray(marketersRes.data)
      ? marketersRes.data.map((row) => ({
          ...row,
          fullName: `${row.f_name || ''} ${row.s_name || ''}`.trim() || row.user_uuid,
        }))
      : [];

    const detailsRes = data[EP] || {};
    this.leadDetails = detailsRes.status === 'OK' ? detailsRes.data || null : null;
    this.leadDetailsError =
      detailsRes.status && detailsRes.status !== 'OK'
        ? (detailsRes.data && detailsRes.data.error) || 'Unable to load lead'
        : null;

    const back = listReturnState.take('ViewLead') || this.listReturnBack || {
      listPage: 'ManageLeads',
      state: {},
    };
    this.listReturnBack = back;
    const activeTab = (await comp.sideNav(this.tabs)) || 'VLd_Details';
    listReturnState.prependBackToSideNav('Back to leads', back);
    await O.changeTab(activeTab, {
      lead_uuid: (this.leadDetails && this.leadDetails.lead_uuid) || (this.vars && this.vars.lead_uuid),
      h_lead_id: this.leadDetails && this.leadDetails.h_lead_id,
    });
  },
};
